import React from 'react';
const PipeTee1Icon = ({ width = 64, height = 64 }) => {
  const id = React.useId().replace(/:/g, '');
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 112.5 112.5">
      <defs>
        <linearGradient id={`${id}_1`} gradientUnits="userSpaceOnUse" x1="49.543" y1="205.125" x2="-8.457" y2="205.125" gradientTransform="matrix(0 1 -1 0 261.375 8.707)">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.16" stopColor="#8F8F8F" />
          <stop offset="0.49" stopColor="#DFDFDF" />
          <stop offset="1" stopColor="#646464" />
        </linearGradient>
        <linearGradient id={`${id}_2`} gradientUnits="userSpaceOnUse" x1="27.25" y1="69.8086" x2="84.75" y2="69.8086">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.18" stopColor="#949494" />
          <stop offset="0.5" stopColor="#DFDFDF" />
          <stop offset="1" stopColor="#656565" />
        </linearGradient>
      </defs>
      <rect y="0.25" fill={`url(#${id}_1)`} width="112.5" height="58" />
      <polygon fill={`url(#${id}_2)`} points="27.25,57.959 56.353,27.118 84.75,56.959 84.75,112.5 27.25,112.5" />
    </svg>
  );
};
export default PipeTee1Icon;
